<template>
  <div class="RMCShowSingleResult">
    <div class="RMCShowSingleResultTitle">
      {{ roundData.name }}
    </div>
    <div class="iconClose-Corner">
      <CrossWhiteIcon @click="closePopover"/>
    </div>
    <div class="RMCShowSingleResultDate"> {{ $t('no.') }} {{ roundData.round }}</div>
    <div class="RMCShowSingleResultDate">{{ roundData.createdDate | moment("DD/MM/YY HH:mm:ss A Z") }}</div>
    <div class="flipResult-sd-container-sedie flipResult-sd-container-numbers">
      <div
          class="flipResult-sd-ball "
          :class="setClassFirstDice"
        >
          1
        </div>
        <div
          class="flipResult-sd-ball"
          :class="setClassSecondDice"
        >
          2
        </div>
        <div
          class="flipResult-sd-ball"
          :class="setClassThirdDice"
        >
          3
        </div>
        <div
          class="flipResult-sd-ball"
          :class="setClassFourthDice"
        >
          4
        </div>
    </div>
    <div class="result-hline"></div>
    <div class="flipResult-sum-row-container">
      <div class="flipResult-sd-container-sum-left">
        <div class="cm-alignCenter flipResult-sd-sum-result">
          <div class="flipResult-sd-sum-ball bg_ad0707 fr-main-bg"></div>
          <div class="flipResult-sd-sum-number">
            {{ totalReds }}
          </div>
        </div>
        <div class="cm-alignCenter flipResult-sd-sum-result">
          <div class="flipResult-sd-sum-ball bg_white fr-main-txt"></div>
          <div class="flipResult-sd-sum-number">
            {{ totalWhites }}
          </div>
        </div>
      </div>
      <div class="result-vline-thin flipResult-sd-vline"></div>
      <div class="flipResult-sd-container-sum-right cm-alignCenter">
        <div class="result-box fr-main-bg flipResult-sd-sum-score">
          {{ (roundData.score !== null && roundData.score.sumScore === "ODD") ? $t('odd') : $t('even') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrossWhiteIcon from '@assets/icons/cross-white.svg';

export default {
  components: {
    CrossWhiteIcon,
  },
  props: {
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    },
  },
  data() {
    return {

    }
  },
  computed: {
    setClassFirstDice: function() {
      if(this.roundData.score != null){
        return this.roundData.score.first.color === 'RED' ? 'flipResult-sd-red fr-main-bg':'flipResult-sd-white';
      }
      return "";
    },
    setClassSecondDice: function() {
      if(this.roundData.score != null){
        return this.roundData.score.second.color === 'RED' ? 'flipResult-sd-red fr-main-bg':'flipResult-sd-white';
      }
      return "";
    },
    setClassThirdDice: function() {
      if(this.roundData.score != null){
        return this.roundData.score.third.color === 'RED' ? 'flipResult-sd-red fr-main-bg':'flipResult-sd-white';
      }
      return "";
    },
    setClassFourthDice: function() {
      if(this.roundData.score != null){
        return this.roundData.score.fourth.color === 'RED' ? 'flipResult-sd-red fr-main-bg':'flipResult-sd-white';
      }
      return "";
    },
    totalReds: function() {
      if(this.roundData.score != null){
        return this.roundData.score.totalRed;
      }
      return "";
    },
    totalWhites: function() {
      if(this.roundData.score != null){
        return this.roundData.score.totalWhite;
      }
      return "";
    },
  },
  mounted() {
    // this.popoverOptions.popoverReference = this.$refs.popoverReference;
  },
  methods: {
    closePopover() {
      // console.log('HistoryDetail - closePopover')
      this.$emit('closePopover');
    },
  }
}
</script>

<style>

</style>
